<template>
  <main>
    <SectionHero :variant="hero.variant" class="privacy-policy__sec">
      <OrganismHero :hero="hero" class="privacy-policy__org" />
    </SectionHero>
    <SectionDefault>
      <Builder :blocks="blocks" />
    </SectionDefault>
  </main>
</template>

<script>
import Builder from '../components/builder/Builder'
import pageBuilder from '../components/mixins/pageBuilder.js'
import OrganismHero from '../components/organisms/layouts/OrganismHero'
import SectionDefault from '../components/templates/layouts/SectionDefault'
import SectionHero from '../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'privacy-policy',
})

export default {
  name: 'PrivacyPolicy',
  components: {
    Builder,
    SectionDefault,
    SectionHero,
    OrganismHero,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      hero: {
        variant: 'dark-parallax',
        title1: 'ПЕРСОНАЛЬНЫЕ',
        title2: 'ДАННЫЕ',
        breadcrumbs: c.$breadcrumbs.privacyPolicy(),
      },
    }
  },
}
</script>
